interface DragDropEvents {
    changeFiles?: (e: DragDropInput) => void;
    createImage?: (wrapper: HTMLElement, id: string) => string | HTMLElement;
}

interface DragDropOptions {
    dropZone: string;
    wrapperImages: string;
    maxFiles?: number;
    on?: DragDropEvents;
    imageWrapperClass?: string;
}

export default class DragDropInput {
    fileList: Map<string, File> = new Map();
    inputElement: { selector: string, target: HTMLInputElement };
    options: DragDropOptions;

    constructor(selector: string, options: DragDropOptions) {
        this.inputElement = { selector, target: document.querySelector(selector) };
        this.options = { imageWrapperClass: 'product-image', ...options }

        this.init()
    }

    init() {
        this.inputChangeHandler()
        this.drogZoneHandler()

        this.deleteImage()
    }

    inputChangeHandler() {
        let { target } = this.inputElement;
        target?.addEventListener('change', (e: Event) => {
            let target = e.target as HTMLInputElement;
            this.handlerImage(target.files)
        })
    }

    drogZoneHandler() {
        let { dropZone } = this.options
        let dropElement = document.querySelector(dropZone) as HTMLElement;

        if (dropElement) {
            dropElement.addEventListener('dragover', (e: DragEvent) => e.preventDefault())
            dropElement.addEventListener('drop', (e: DragEvent) => {
                e.preventDefault();
                this.handlerImage(e.dataTransfer.files)
            })
        }
    }

    handlerImage(files: FileList) {
        let { on, imageWrapperClass, wrapperImages, maxFiles } = this.options;
        let { target } = this.inputElement

        //if (maxFiles && this.fileList.size >= maxFiles) return this.showAlert(`Solo tiene un maximo de ${maxFiles} imagenes para subir`)
        if (maxFiles && this.fileList.size >= maxFiles){
            let containerFile = document.querySelector('#drop_zone') as any;
            containerFile.style.display = 'none';
            let textError = document.querySelector('.field-products__error') as any;
            textError.innerHTML = `Límite de imágenes alcanzado, solo puedes subir ${maxFiles} imágenes para tu emprendimiento`;
            this.showAlert(`Solo tiene un maximo de ${maxFiles} imagenes para subir`)
        }

        let nwData = new DataTransfer();
        let nwFiles: Map<string, File> = this.fileList;

        Array.from(files).slice(0, maxFiles - this.fileList.size).forEach(file => {

            if (!file.type.includes('image')) return
            let { number, type } = this.convertBytes(file.size)
            if (type == 'MB' && number > 2) return this.showAlert(`Las imagenes no deben pesar mas de 2 MB`)

            let source = URL.createObjectURL(file);
            let product = new ProductImage(imageWrapperClass)
            let image = product.createImage(source, on?.createImage)

            if (typeof image === 'string') { document.querySelector(wrapperImages)?.insertAdjacentHTML('beforeend', image) }
            else document.querySelector(wrapperImages)?.insertAdjacentElement('beforeend', image)

            nwFiles.set(product.getId(), file)
        })

        this.fileList = nwFiles;
        this.fileList.forEach((file: File) => nwData.items.add(file))

        target.files = nwData.files
        document.querySelector('.trnz-counter-images__upload').innerHTML = `${this.fileList.size}`

        if (on) on.changeFiles?.(this)
    }

    deleteImage() {
        let { imageWrapperClass, wrapperImages } = this.options
        let productSwiper = document.querySelector(wrapperImages)
        productSwiper?.addEventListener('click', (e: any) => {
            if (e.target.classList.contains(`${imageWrapperClass}__delete`)) {
                let idImage = e.target.getAttribute('data-image-id')
                document.getElementById(idImage)?.remove()
                this.removeFile(idImage)
                let containerFile = document.querySelector('#drop_zone') as any;
                containerFile.style.display = 'flex';
                let textError = document.querySelector('.field-products__error') as any;
                textError.innerHTML = '';
            }
        })
    }

    removeFile(idImage: string) {
        let { target } = this.inputElement
        let { on } = this.options;
        let nwData = new DataTransfer();

        this.fileList.delete(idImage)
        this.fileList.forEach((file: File) => nwData.items.add(file))

        target.files = nwData.files
        document.querySelector('.trnz-counter-images__upload').innerHTML = `${this.fileList.size}`

        if (on) on.changeFiles?.(this)
    }

    showAlert(message: string) {
        document.querySelector('#popupAlert')?.classList.remove('trnz-popup--hide')
        let noTimeMessage = document.querySelector('#alertMessage')
        if (noTimeMessage) noTimeMessage.innerHTML = message
    }

    convertBytes(bytes: number): { number: number, type: string } {
        let kilobytes = bytes / 1024
        if (bytes > 1e6) {
            let megabytes = (kilobytes / 1024).toFixed(1)
            return { number: parseFloat(megabytes), type: 'MB' }
        }
        return { number: Math.round(kilobytes), type: 'KB' }
    }
}

class ProductImage {
    id: string;
    src: string;
    target: HTMLElement;
    mainClass: string;

    constructor(mainClass: string) {
        this.src = ''
        this.mainClass = mainClass
        this.id = generator.generate()
    }

    createImage(src: string, callback: (wrapper: HTMLElement, id: string) => string | HTMLElement): string | HTMLElement {
        this.target = document.createElement('div')
        this.target.classList.add(this.mainClass)

        let deleteBtn = document.createElement('span') as HTMLSpanElement;
        deleteBtn.classList.add(`${this.mainClass}__delete`)
        deleteBtn.setAttribute('data-image-id', this.id)

        let image = document.createElement('img') as HTMLImageElement
        image.classList.add(`${this.mainClass}__source`)
        image.src = src;

        this.target.appendChild(deleteBtn)
        this.target.appendChild(image)

        if (callback) {
            return callback(this.target, this.id);
        }
        else {
            this.target.id = this.id
            return this.target;
        }
    }

    getId(): string {
        return this.id
    }
}

class IdGenerator {
    idList: Array<string>;

    constructor() {
        this.idList = []
    }

    generate(): string {
        let nwId = (Math.random() + 1).toString(36).substring(7)
        if (!this.idList.includes(nwId)) {
            this.idList.push(nwId)
            return nwId
        }
        return this.generate()
    }
}

let generator = new IdGenerator()